import React from "react";
import {useTranslation} from "react-i18next";
import DialogCloseButton from "../buttons/DialogCloseButton";

interface OptionDialogProps {
    open: boolean;
    title: string;
    message: string;
    firstOptionLabel: string;
    secondOptionLabel: string;
    cancelLabel?: string;
    onFirstOption: () => void;
    onSecondOption: () => void;
    disableFirstOption?: boolean;
    disableSecondOption?: boolean;
    tooltipFirstOption?: string;
    tooltipSecondOption?: string;
    onClose: () => void;
}

function OptionDialog({
                          open,
                          title,
                          message,
                          firstOptionLabel,
                          secondOptionLabel,
                          cancelLabel,
                          onFirstOption,
                          onSecondOption,
                          disableFirstOption,
                          disableSecondOption,
                          tooltipFirstOption,
                          tooltipSecondOption,
                          onClose
                      }: OptionDialogProps) {
    const {t} = useTranslation();
    if (!open) return null;

    const handleFirstOption = () => {
        onFirstOption();
        onClose();
    }

    const handleSecondOption = () => {
        onSecondOption();
        onClose();
    }

    return (
        <div className="dialog-overlay">
            <div className="dialog confirmation-dialog">
                <DialogCloseButton onClose={onClose}/>

                <div>
                    <h3>{title}</h3>
                    <p>{message}</p>
                </div>


                <div className="dialog-actions">
                    <button
                        type="button"
                        className="form-button"
                        onClick={handleFirstOption}
                        disabled={disableFirstOption}
                        title={tooltipFirstOption}
                    >
                        {firstOptionLabel}
                    </button>
                    <button
                        type="button"
                        className="form-button-secondary"
                        onClick={handleSecondOption}
                        disabled={disableSecondOption}
                        title={tooltipSecondOption}
                    >
                        {secondOptionLabel}
                    </button>
                    <button
                        type="button"
                        className="form-button-secondary"
                        onClick={onClose}
                    >
                        {cancelLabel || t("common.button.cancel")}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default OptionDialog;